import { render } from "./LoyaltySettings.vue?vue&type=template&id=1098f073&scoped=true"
import script from "./LoyaltySettings.vue?vue&type=script&lang=js"
export * from "./LoyaltySettings.vue?vue&type=script&lang=js"

import "./LoyaltySettings.vue?vue&type=style&index=0&id=1098f073&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1098f073"]])

export default __exports__